import React, { useState, useEffect } from "react";
 
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import DesktopWindowsOutlinedIcon from "@material-ui/icons/DesktopWindowsOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import SchoolOutlinedIcon from "@material-ui/icons/SchoolOutlined";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
 
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  IconButton,
   Typography,
} from "@material-ui/core";
 
import CloseIcon from "@material-ui/icons/Close";
 
import landinglogo from "assets/img/hs_landing.png";
import ThriveSignaturegep from "assets/img/Thrive Signaturegep.png";
 
import { toast } from "react-toastify";
 
import upgardeloyalty from "apis/UpgradeLoyalty/upgardeloyalty";
import moment from "moment";

 
import ThriveSignatureUpgrade from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureUpgrade";
import ThriveSignatureConfirmation from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureConfirmation";
import ThriveSignatureEligibility from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureEligibility";
import ThriveSignatureNotEligible from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureNotEligible";
import ThriveSignatureInprogress from "views/AuthPages/OneWeb/Thrive-Signature-Landing-Enrollment/ThriveSignatureInprogress";
import ThriveSignatureRequests from 'apis/ThriveSignatureRequest/ThriveSignatureRequest';
 
 
export default function ThriveSignature() {
  const [shipto, setShipto] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [termlink, setTermlink] = useState("");
  const [data, setData] = useState({});
const [reasonData, setReasonData] = useState([]);
const [value, setValue] = useState(0);
 const { createUnenrollmentReqAPI } = ThriveSignatureRequests();
 
  const [signatureData, setSignatureData] = useState({});
  const [openUnenrollment, setOpenUnenrollment] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
const [formErrors, setFormErrors] = useState({});
const [unenrollmentData, setUnenrollmentData] = useState({
  shipto: "",
  reason: "",
  cancellationNotes: "",
});
 
  const {
    getLinks,
    getsignatureDetail,
    getsignatureUnenrollmentReason,
  } = upgardeloyalty();
 
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await getLinks({
          country: "us",
        });
 
        const linksData = response?.data || {};
 
        setTermlink(
          linksData?.thrivesignatureLink || ""
        );
      } catch (error) {
        console.error(error);
      }
    };
 
    fetchLinks();
  }, []);
 
 
  useEffect(() => {
  handleGetRole();
}, []);
 
const handleGetRole = async () => {
  try {
    const res = await getsignatureUnenrollmentReason();
 
    if (res) {
      setData(res);
      setReasonData(res.reason || []);
 
      if (res?.team === "signature") {
        setValue(0);
      }
    }
  } catch (e) {
    console.error("Get error:", e);
  }
};
 
    const handleSearch = async () => {
    if (!shipto) {
      toast.error("Please enter the account number");
      return;
    }
 
    try {
      setLoading(true);
 
      const values = {
        shipto: shipto,
      };
 
      const res = await getsignatureDetail(values);
 
      if (res?.result_status == 0) {
        if (res?.signature_status == "enrolled") {
            setSignatureData({
              practiceName: res?.practiceName || "",
              city: res?.city || "",
              state: res?.state || "",
              title: res?.title || "",
              ownerfirstname: res?.ownerfirstname || "",
              ownerlastname: res?.ownerlastname || "",
              contactfirstname: res?.contactfirstname || "",
              contactlastname: res?.contactlastname || "",
              customeremail: res?.customeremail || "",
              officenumber: res?.officenumber || "",
              shipto: shipto || "",
               submiteddate : res?.submiteddate || "",
              plan:res?.plan || "",
              trialperiod:res?.trialperiod || ""
  });
          setMessage("3");
           setShipto("")
         
 
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
 
        if (res?.signature_status == "pending") {
 
           setSignatureData({
            practiceName: res?.practiceName || "",
            city: res?.city || "",
            state: res?.state || "",
            title: res?.title || "",
            ownerfirstname: res?.ownerfirstname || "",
            ownerlastname: res?.ownerlastname || "",
            contactfirstname: res?.contactfirstname || "",
            contactlastname: res?.contactlastname || "",
            customeremail: res?.customeremail || "",
            officenumber: res?.officenumber || "",
            shipto: shipto || "",
            submiteddate : res?.submiteddate|| "",
            plan:res?.plan|| ""
  });
          setMessage("5");
 
           setShipto("")
         
         
 
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
 
        if (res?.signature_status == "noteligible") {
            setSignatureData({
          practiceName: res?.practiceName || "",
          shipto: shipto,
  });
          setMessage("4");
           setShipto("")
         
 
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
 
        if (res?.message == "Please enter a valid Location Account Number") {
          toast.error(res.message);
        }
 
        if (
          res?.message ==
          "This account is currently inactive and is not eligible for enrollment"
        ) {
          toast.error(res.message);
        }
      }
 
      if (res?.result_status == 1) {
       
        if (res?.data?.signature_status === "Eligibility") {
          setSignatureData({
            practiceName: res?.data?.practiceName || "",
            city: res?.data?.city || "",
            state: res?.data?.state || "",
            thrivesignatureLink: res?.data?.thrivesignatureLink || "",
            thrivesignaturetermconditionLink: res?.data?.thrivesignaturetermconditionLink || "",
            GEPLink:res?.data?.GEPLink || "",
            shipto: shipto,
  });
 
   setShipto("")
 
         
 
         
          setMessage("1");
 
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
      }
    } catch (error) {
      console.error(error);
 
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
 
  if (message === "1") {
      return <ThriveSignatureUpgrade setNext={setMessage}  signatureData={signatureData}   setSignatureData={setSignatureData} />;
    }
 
    if (message === "2") {
      return <ThriveSignatureConfirmation setNext={setMessage} signatureData={signatureData}  />;
    }
 
    if (message === "3") {
      return <ThriveSignatureEligibility setNext={setMessage} signatureData={signatureData} />;
    }
 
    if (message === "4") {
      return <ThriveSignatureNotEligible setNext={setMessage}  signatureData={signatureData} />;
    }
 
    if (message === "5") {
      return <ThriveSignatureInprogress setNext={setMessage}  signatureData={signatureData}/>;
    }
 
    const handleOpenUnenrollment = () => {
  setUnenrollmentData({
    shipto: "",
    reason: "",
    cancellationNotes: "",
  });
 
  setFormErrors({});
  setOpenUnenrollment(true);
};
 
// Close dialog
const handleCloseUnenrollment = () => {
  if (btnLoading) return;
 
  setOpenUnenrollment(false);
  setFormErrors({});
};
 
// Update form fields
const handleUnenrollmentChange = (field, value) => {
  setUnenrollmentData((prev) => ({
    ...prev,
    [field]: value,
  }));
 
  setFormErrors((prev) => ({
    ...prev,
    [field]: "",
  }));
};
 
// Validate required fields
const validateUnenrollmentForm = () => {
  const errors = {};
 
  if (!unenrollmentData.shipto?.trim()) {
    errors.shipto = "Please enter Shipto";
  }
 
  if (!unenrollmentData.reason?.trim()) {
    errors.reason = "Please select a cancellation reason";
  }
 
  if (!unenrollmentData.cancellationNotes?.trim()) {
    errors.cancellationNotes = "Please provide cancellation notes";
  }
 
  setFormErrors(errors);
 
  return Object.keys(errors).length === 0;
};
 
// Submit API
const handleCreateSubmit = async () => {
  if (btnLoading) return;
 
  if (!validateUnenrollmentForm()) {
    return;
  }
 
  setBtnLoading(true);
 
  try {
    const payload = {
      shipto: unenrollmentData.shipto.trim(),
      reason: unenrollmentData.reason.trim(),
      cancellationNotes: unenrollmentData.cancellationNotes.trim(),
      unEnrollmentDate: moment().format('YYYY-MM-DD'),
    };
 
    const res = await createUnenrollmentReqAPI(payload);
 
    if (res?.success) {
      toast.success(
        res?.message ||
          "Unenrollment request created successfully",
        { toastId: "unenrollment-request" }
      );
 
      setOpenUnenrollment(false);
 
      setUnenrollmentData({
        shipto: "",
        reason: "",
        cancellationNotes: "",
      });
 
      setFormErrors({});
    } else {
      toast.error(
        res?.message || "Submission failed. Please try again.",
        { toastId: "unenrollment-request" }
      );
    }
  } catch (error) {
    console.error("Create unenrollment API error:", error);
 
    toast.error("API error. Please try again later.", {
      toastId: "unenrollment-request",
    });
  } finally {
    setBtnLoading(false);
  }
};
 
 
  return (
    <>
      <style>{responsiveCss}</style>
 
      <div className="signature-page">
 
        {/* TOP BANNER */}
        <div className="top-banner">
          <div className="banner-inner">
 
            <div className="banner-brand">
              <img
                src={landinglogo}
                alt="Henry Schein"
                className="banner-hs-logo"
              />
            </div>
 
            <div className="banner-divider" />
 
            <div className="banner-tagline">
              Save More. Do More.{" "}
              <span>Thrive.</span>
            </div>
 
          </div>
        </div>
 
        {/* MAIN CARD */}
        <div className="outer-card">
 
          {/* STEPS */}
          <div className="steps-container">
 
            <Step
              number="1"
              title="Check Eligibility"
              active
            />
 
            <div className="step-line" />
 
            <Step
              number="2"
              title="Review & Accept"
            />
 
            <div className="step-line" />
 
            <Step
              number="3"
              title="Confirmation"
            />
 
          </div>
 
          {/* HEADING */}
          <div className="page-heading">
 
            <h1>
              Upgrade to Thrive Signature
            </h1>
 
            <p>
              Unlock enhanced rewards, shipping benefits,
              service savings, and more with Thrive Signature.
            </p>
 
          </div>
 
          {/* SIGNATURE CARD */}
          <div className="signature-card">
 
            {/* LOGO */}
            <div className="signature-brand">
 
              <img
                src={ThriveSignaturegep}
                alt="Thrive Signature"
                className="signature-logo"
              />
 
            </div>
 
            {/* SAVINGS */}
            <div className="savings-banner">
 
              <strong>$6,500+</strong>
 
              <span>
                Average Annual Savings with Thrive Signature*
              </span>
 
            </div>
 
            <div className="card-divider" />
 
            {/* BENEFIT TITLE */}
            <div className="benefit-heading">
 
              More rewards. More benefits. More value
              <br />
              from your membership.
 
            </div>
 
            {/* BENEFITS */}
            <div className="benefits-list">
 
              <SignatureBenefit
                icon={
                  <MonetizationOnOutlinedIcon />
                }
                text="5X Points on Henry Schein Products"
              />
 
              <SignatureBenefit
                icon={
                  <DesktopWindowsOutlinedIcon />
                }
                text="3X Points on Equipment & Technology"
              />
 
              <SignatureBenefit
                icon={
                  <LocalShippingOutlinedIcon />
                }
                text="Shipping Included on Orders $249+"
              />
 
              <SignatureBenefit
                icon={<BuildOutlinedIcon />}
                text="$200 off Hourly Service Labor"
              />
 
              <SignatureBenefit
                icon={<SchoolOutlinedIcon />}
                text="100+ Hours of Continuous Education Credits"
              />
 
              <SignatureBenefit
                icon={<StarBorderIcon />}
                text="And So Much More!"
              />
 
            </div>
 
            {/* PRICE */}
            <div className="price-area">
 
              <div className="price-line" />
 
              <div className="price-text">
                $115/month or $1,299/year*
              </div>
 
              <div className="price-line" />
 
            </div>
 
            {/* ELIGIBILITY */}
            <div className="eligibility-section">
 
              <h2>
                Ready to upgrade? Check your eligibility.
              </h2>
 
              <p>
                Enter your Location Account Number to confirm
                your practice is eligible
                <br className="desktop-break" />
                to upgrade to Thrive Signature.
              </p>
 
              {/* ACCOUNT NUMBER */}
              <div className="input-section">
 
                <div className="account-label">
 
                  <label>
                    Account Number
                  </label>
 
                  {/* INFORMATION ICON */}
                  <div className="account-help">
 
                    <InfoOutlinedIcon
                      className="account-info-icon"
                    />
 
                    {/* TOOLTIP */}
                    <div className="account-tooltip">
 
                      <span>
                        Need help finding your Location Account Number? Find it on any invoice or order confirmation
                      </span>
 
                      {/* <span>
                        Find it on any invoice or order confirmation
                      </span> */}
 
                    </div>
 
                  </div>
 
                </div>
 
                <input
                  type="text"
                  inputMode="numeric"
                  value={shipto}
                  placeholder="Enter Location Account Number"
                  autoComplete="off"
                  onChange={(e) => {
 
                    const value =
                      e.target.value;
 
                    if (/^\d*$/.test(value)) {
                      setShipto(value);
                    }
 
                  }}
                />
 
              </div>
 
              {/* BUTTON */}
              <button
                className="check-button"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading
                  ? "Checking..."
                  : "Check Eligibility"}
              </button>
 
 
              {/* <Typography
  component="span"
  onClick={handleOpenUnenrollment}
  style={{
    color: "#1976d2",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline-block",
    marginTop: 12,
  }}
>
  Create Unenrollment Request
</Typography> */}
 
            </div>
 
          </div>
 
          {/* TERMS */}
          <div className="terms-section">
 
            <div className="terms-main">
              *Annual commitment required with yearly payment option.
            </div>
 
            <div className="terms-sub">
 
              Additional terms and conditions may apply.
              Please refer to{" "}
 
              <a
                href={termlink || "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                Henry Schein Thrive Service Agreement (TSSA)
              </a>{" "}
 
              for full Thrive Signature benefit details.
 
            </div>
 
          </div>
 
          {/* BOTTOM INFORMATION */}
          <div className="information-section">
 
            <InformationItem
              icon={<StarBorderIcon />}
              title="Your Rewards membership stays active"
              description={
                <>
                  Upgrading adds Signature benefits
                  <br className="desktop-break" />
                  to your existing Thrive Rewards
                  <br className="desktop-break" />
                  membership.
                </>
              }
            />
 
            <div className="information-divider" />
 
            <InformationItem
              icon={<HelpOutlineIcon />}
              title="Questions?"
              description={
                <>
                  Contact your Henry Schein Sales
                  <br className="desktop-break" />
                  Consultant or
                  <br className="desktop-break" />
 
                  <a
                    href="mailto:Thrive.Support@henryschein.com"
                    className="support-link"
                  >
                    Thrive.Support@henryschein.com
                  </a>
                </>
              }
            />
 
            <div className="information-divider" />
 
            <InformationItem
              icon={<LockOutlinedIcon />}
              title="Secure Enrollment"
              description="Your information is protected."
            />
 
            <Dialog
  open={openUnenrollment}
  onClose={handleCloseUnenrollment}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span>Create Unenrollment Request</span>
 
      <IconButton
        onClick={handleCloseUnenrollment}
        disabled={btnLoading}
        size="small"
      >
        <CloseIcon />
      </IconButton>
    </div>
  </DialogTitle>
 
  <DialogContent dividers>
    {/* Shipto */}
    <TextField
      label="Shipto"
      required
      fullWidth
      margin="normal"
      variant="outlined"
      value={unenrollmentData.shipto}
      error={Boolean(formErrors.shipto)}
      helperText={formErrors.shipto}
      onChange={(e) =>
        handleUnenrollmentChange("shipto", e.target.value)
      }
    />
 
    {/* Reason dropdown */}
    <TextField
      select
      label="Reason"
      required
      fullWidth
      margin="normal"
      variant="outlined"
      value={unenrollmentData.reason}
      error={Boolean(formErrors.reason)}
      helperText={formErrors.reason}
      onChange={(e) =>
        handleUnenrollmentChange("reason", e.target.value)
      }
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        },
      }}
    >
      {reasonData.map((item, index) => (
        <MenuItem
          key={`${item.reason_description}-${index}`}
          value={item.reason_description}
          style={{
            backgroundColor:
              item.reason_description === "Others"
                ? "#FFFF00"
                : "transparent",
          }}
        >
          {item.reason_description}
        </MenuItem>
      ))}
    </TextField>
 
    {/* Cancellation Notes */}
    <TextField
      label="Cancellation Notes"
      required
      fullWidth
      // multiline
      rows={4}
      margin="normal"
      variant="outlined"
      value={unenrollmentData.cancellationNotes}
      error={Boolean(formErrors.cancellationNotes)}
      helperText={formErrors.cancellationNotes}
      onChange={(e) =>
        handleUnenrollmentChange(
          "cancellationNotes",
          e.target.value
        )
      }
    />
  </DialogContent>
 
  <DialogActions style={{ padding: "16px 24px" }}>
    <Button
      onClick={handleCloseUnenrollment}
      color="default"
      disabled={btnLoading}
    >
      Cancel
    </Button>
 
    <Button
      onClick={handleCreateSubmit}
      color="primary"
      variant="contained"
      disabled={btnLoading}
    >
      {btnLoading ? "Submitting..." : "Submit"}
    </Button>
  </DialogActions>
</Dialog>
 
          </div>
 
        </div>
 
      </div>
 
 
    </>
  );
}
 
 
/* =====================================================
   STEP
===================================================== */
 
const Step = ({
  number,
  title,
  active,
}) => {
 
  return (
    <div
      className={
        active
          ? "step active"
          : "step"
      }
    >
 
      <div className="step-number">
        {number}
      </div>
 
      <div className="step-title">
        {title}
      </div>
 
    </div>
  );
};
 
 
/* =====================================================
   BENEFIT
===================================================== */
 
const SignatureBenefit = ({
  icon,
  text,
}) => {
 
  return (
    <div className="signature-benefit">
 
      <div className="benefit-icon">
        {icon}
      </div>
 
      <div className="benefit-text">
        {text}
      </div>
 
    </div>
  );
};
 
 
/* =====================================================
   INFORMATION ITEM
===================================================== */
 
const InformationItem = ({
  icon,
  title,
  description,
}) => {
 
  return (
    <div className="information-item">
 
      <div className="information-icon">
        {icon}
      </div>
 
      <div className="information-content">
 
        <div className="information-title">
          {title}
        </div>
 
        <div className="information-description">
          {description}
        </div>
 
      </div>
 
    </div>
  );
};
 
 
/* =====================================================
   CSS
===================================================== */
 
const responsiveCss = `
 
* {
  box-sizing: border-box;
}
 
 
/* =========================================
   PAGE
========================================= */
 
.signature-page {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0 0 25px;
 
  font-family: Arial, Helvetica, sans-serif;
 
  color: #0E176D;
 
  background:
    linear-gradient(
      135deg,
      #F4FAFF 0%,
      #FFFFFF 45%,
      #EEF8FF 100%
    );
 
  overflow-x: hidden;
}
 
 
/* =========================================
   TOP BANNER
========================================= */
 
.top-banner {
  width: 100%;
  height: 110px;
 
  position: relative;
  overflow: hidden;
 
  background:
    linear-gradient(
      135deg,
      #E4F6FF 0%,
      #D3EFFD 22%,
      #F3FBFF 47%,
      #D3EEFC 72%,
      #E8F8FF 100%
    );
}
 
.top-banner::before {
  content: "";
 
  position: absolute;
 
  left: -70px;
  top: -100px;
 
  width: 350px;
  height: 260px;
 
  background:
    linear-gradient(
      135deg,
      transparent 47%,
      rgba(77, 169, 232, 0.20) 48%,
      rgba(77, 169, 232, 0.20) 63%,
      transparent 64%
    );
 
  transform: rotate(-5deg);
}
 
.top-banner::after {
  content: "";
 
  position: absolute;
 
  right: -60px;
  top: -90px;
 
  width: 380px;
  height: 280px;
 
  background:
    linear-gradient(
      135deg,
      transparent 48%,
      rgba(72, 163, 228, 0.20) 49%,
      rgba(72, 163, 228, 0.20) 65%,
      transparent 66%
    );
 
  transform: rotate(-5deg);
}
 
.banner-inner {
  width: 100%;
  max-width: 760px;
 
  height: 100%;
 
  margin: 0 auto;
 
  padding-left: 28px;
  padding-top: 14px;
 
  position: relative;
  z-index: 2;
 
  display: flex;
  align-items: flex-start;
 
  gap: 12px;
}
 
.banner-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
 
  flex-shrink: 0;
}
 
.banner-hs-logo {
  width: 105px;
  height: auto;
 
  object-fit: contain;
}
 
.banner-divider {
  width: 1px;
  height: 39px;
 
  margin-top: 4px;
 
  background: #A9BFD8;
 
  flex-shrink: 0;
}
 
.banner-tagline {
  margin-top: 5px;
 
  color: #1638CA;
 
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
 
  white-space: nowrap;
}
 
.banner-tagline span {
  color: #2F9BE8;
}
 
 
/* =========================================
   OUTER CARD
========================================= */
 
.outer-card {
  width: calc(100% - 30px);
  max-width: 760px;
 
  margin: -42px auto 0;
 
  padding: 18px 20px 15px;
 
  position: relative;
  z-index: 3;
 
  background: #FFFFFF;
 
  border: 1px solid #E3EDF8;
  border-radius: 5px;
 
  box-shadow:
    0 6px 24px rgba(25, 91, 170, 0.10);
}
 
 
/* =========================================
   STEPS
========================================= */
 
.steps-container {
  width: 100%;
 
  display: flex;
  align-items: flex-start;
  justify-content: center;
 
  margin: 0 auto 14px;
}
 
.step {
  width: 110px;
 
  flex-shrink: 0;
 
  display: flex;
  flex-direction: column;
  align-items: center;
}
 
.step-number {
  width: 26px;
  height: 26px;
 
  border-radius: 50%;
 
  display: flex;
  align-items: center;
  justify-content: center;
 
  background: #E9EFFB;
 
  border: 1px solid #D5E0EF;
 
  color: #5A76D9;
 
  font-size: 11px;
  font-weight: 700;
}
 
.step.active .step-number {
  background: #166DE5;
 
  border-color: #166DE5;
 
  color: #FFFFFF;
 
  box-shadow:
    0 3px 8px rgba(22, 109, 229, 0.25);
}
 
.step-title {
  margin-top: 5px;
 
  color: #6076C9;
 
  font-size: 9.5px;
  line-height: 12px;
 
  text-align: center;
 
  white-space: nowrap;
}
 
.step.active .step-title {
  color: #1765DE;
  font-weight: 700;
}
 
.step-line {
  width: 100px;
  height: 1px;
 
  margin-top: 13px;
 
  background: #D1DCEC;
}
 
 
/* =========================================
   HEADING
========================================= */
 
.page-heading {
  text-align: center;
 
  margin: 0 auto 14px;
}
 
.page-heading h1 {
  margin: 0 0 4px;
 
  color: #142CD2;
 
  font-size: 26px;
  line-height: 32px;
 
  font-weight: 700;
}
 
.page-heading p {
  margin: 0 auto;
 
  max-width: 640px;
 
  color: #1B3FD0;
 
  font-size: 12.5px;
  line-height: 18px;
}
 
 
/* =========================================
   SIGNATURE CARD
========================================= */
 
.signature-card {
  width: 100%;
  max-width: 370px;
 
  margin: 0 auto;
 
  padding: 14px 18px 18px;
 
  background: #FFFFFF;
 
  border: 1px solid #5DB6F6;
  border-radius: 5px;
 
  box-shadow:
    0 4px 16px rgba(0, 120, 230, 0.10);
}
 
.signature-brand {
  display: flex;
  justify-content: center;
  align-items: center;
 
  margin-bottom: 10px;
}
 
.signature-logo {
  width: 104px;
  height: auto;
 
  object-fit: contain;
}
 
 
/* =========================================
   SAVINGS
========================================= */
 
.savings-banner {
  width: 100%;
  min-height: 34px;
 
  padding: 6px 8px;
 
  display: flex;
  align-items: center;
  justify-content: center;
 
  gap: 5px;
 
  background: #E3F1FF;
 
  border-radius: 3px;
 
  text-align: center;
 
  color: #153DD5;
}
 
.savings-banner strong {
  font-size: 15px;
  line-height: 18px;
  font-weight: 700;
}
 
.savings-banner span {
  font-size: 10.5px;
  line-height: 14px;
  font-weight: 600;
}
 
.card-divider {
  width: 100%;
  height: 1px;
 
  margin: 10px 0 0;
 
  background: #CFDCF0;
}
 
 
/* =========================================
   BENEFITS
========================================= */
 
.benefit-heading {
  margin: 10px 0 8px;
 
  text-align: center;
 
  color: #1636D2;
 
  font-size: 15px;
  line-height: 20px;
 
  font-weight: 700;
}
 
.benefits-list {
  width: 100%;
 
  padding-left: 32px;
}
 
.signature-benefit {
  width: 100%;
  min-height: 36px;
 
  display: flex;
  align-items: center;
 
  gap: 18px;
 
  padding: 3px 0;
}
 
.benefit-icon {
  width: 27px;
  height: 27px;
 
  flex-shrink: 0;
 
  border-radius: 50%;
 
  display: flex;
  align-items: center;
  justify-content: center;
 
  background: #DCECFF;
 
  border: 1px solid #C3DCF7;
 
  color: #1564E3;
}
 
.benefit-icon svg {
  font-size: 16px;
}
 
.benefit-text {
  color: #4A68CF;
 
  font-size: 11px;
  line-height: 15px;
 
  font-weight: 400;
}
 
 
/* =========================================
   PRICE
========================================= */
 
.price-area {
  width: 100%;
  margin-top: 6px;
}
 
.price-line {
  width: 100%;
  height: 1px;
 
  background: #CEDBF0;
}
 
.price-text {
  padding: 9px 0;
 
  text-align: center;
 
  color: #1436D5;
 
  font-size: 15px;
  line-height: 20px;
 
  font-weight: 700;
}
 
 
/* =========================================
   ELIGIBILITY
========================================= */
 
.eligibility-section {
  width: 100%;
 
  margin-top: 12px;
 
  text-align: center;
}
 
.eligibility-section h2 {
  margin: 0 0 5px;
 
  color: #1436D5;
 
  font-size: 12.5px;
  line-height: 17px;
 
  font-weight: 700;
}
 
.eligibility-section p {
  margin: 0 auto 10px;
 
  color: #5871D0;
 
  font-size: 9px;
  line-height: 13px;
}
 
 
/* =========================================
   ACCOUNT LABEL
========================================= */
 
.input-section {
  width: 100%;
  text-align: left;
}
 
.account-label {
  display: flex;
  align-items: center;
 
  gap: 6px;
 
  margin-bottom: 5px;
}
 
.account-label label {
  margin: 0;
 
  color: #152CD1;
 
  font-size: 10px;
  line-height: 13px;
 
  font-weight: 700;
}
 
 
/* =========================================
   INFORMATION ICON
========================================= */
 
.account-help {
  position: relative;
 
  width: 20px;
  height: 20px;
 
  flex-shrink: 0;
 
  display: flex;
  align-items: center;
  justify-content: center;
 
  cursor: pointer;
 
  border-radius: 50%;
 
  /* LIGHT BLUE BACKGROUND */
  background: #DCEEFF;
}
 
.account-info-icon {
  width: 14px !important;
  height: 14px !important;
 
  /* DARK BLUE ICON */
  color: #1456D8;
 
  font-size: 14px !important;
}
 
.account-help:hover {
  background: #CFE5FF;
}
 
.account-help:hover .account-info-icon {
  color: #0E3FA8;
}
 
 
/* =========================================
   TOOLTIP
   DESKTOP -> RIGHT SIDE
========================================= */
 
.account-tooltip {
  position: absolute;
 
  left: 25px;
  right: auto;
 
  top: 50%;
  bottom: auto;
 
  width: 190px;
 
  padding: 8px 10px;
 
  background: #F2F8FF;
 
  border: 1px solid #C6D9EF;
  border-radius: 4px;
 
  box-shadow:
    0 3px 10px rgba(40, 90, 150, 0.14);
 
  opacity: 0;
  visibility: hidden;
 
  transform:
    translateY(-50%)
    translateX(4px);
 
  transition:
    opacity 0.15s ease,
    visibility 0.15s ease,
    transform 0.15s ease;
 
  z-index: 20;
 
  text-align: left;
}
 
.account-tooltip::before {
  content: "";
 
  position: absolute;
 
  left: -5px;
  top: 50%;
 
  width: 9px;
  height: 9px;
 
  background: #F2F8FF;
 
  border-left: 1px solid #C6D9EF;
  border-bottom: 1px solid #C6D9EF;
 
  transform:
    translateY(-50%)
    rotate(45deg);
}
 
.account-tooltip strong {
  display: block;
 
  margin-bottom: 2px;
 
  color: #5570BE;
 
  font-size: 8.5px;
  line-height: 11px;
 
  font-weight: 600;
}
 
.account-tooltip span {
  display: block;
 
  color: #6C7EB8;
 
  font-size: 8px;
  line-height: 11px;
}
 
 
/* =========================================
   HOVER
========================================= */
 
.account-help:hover .account-tooltip {
  opacity: 1;
  visibility: visible;
 
  transform:
    translateY(-50%)
    translateX(0);
}
 
 
/* =========================================
   INPUT
========================================= */
 
.input-section input {
  width: 100%;
  height: 30px;
 
  padding: 6px 10px;
 
  border: 1px solid #B7C7E2;
  border-radius: 3px;
 
  outline: none;
 
  background: #FFFFFF;
 
  color: #172C72;
 
  font-size: 10.5px;
}
 
.input-section input::placeholder {
  color: #7184BD !important;
}
 
.input-section input:focus {
  border-color: #1887F5;
 
  box-shadow:
    0 0 0 2px rgba(24, 135, 245, 0.10);
}
 
 
/* =========================================
   BUTTON
========================================= */
 
.check-button {
  width: 100%;
  height: 32px;
 
  margin-top: 8px;
 
  border: none;
  border-radius: 3px;
 
  background: #0878E8;
 
  color: #FFFFFF;
 
  font-size: 11px;
  font-weight: 700;
 
  cursor: pointer;
}
 
.check-button:hover {
  background: #056BD3;
}
 
.check-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
 
 
/* =========================================
   TERMS
========================================= */
 
.terms-section {
  width: 100%;
 
  margin: 10px auto 0;
 
  text-align: center;
 
  color: #5E72BB;
 
  font-size: 8.5px;
  line-height: 12px;
}
 
.terms-main {
  margin-bottom: 2px;
}
 
.terms-sub {
  max-width: 650px;
 
  margin: 0 auto;
}
 
.terms-sub a {
  color: #2856B8;
  text-decoration: underline;
}
 
 
/* =========================================
   BOTTOM INFORMATION
========================================= */
 
.information-section {
  width: 100%;
 
  margin: 18px auto 0;
 
  padding: 11px 6px 4px;
 
  display: flex;
  align-items: stretch;
 
  border-top: 1px solid #C9D9EC;
}
 
.information-item {
  flex: 1;
 
  display: flex;
  align-items: center;
 
  gap: 8px;
 
  padding: 0 10px;
}
 
.information-icon {
  width: 32px;
  height: 32px;
 
  flex-shrink: 0;
 
  border-radius: 50%;
 
  background: #DCEEFF;
 
  color: #176DE2;
 
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.information-icon svg {
  font-size: 18px;
}
 
.information-content {
  min-width: 0;
}
 
.information-title {
  color: #1456D8;
 
  font-size: 9px;
  line-height: 12px;
 
  font-weight: 700;
 
  margin-bottom: 2px;
}
 
.information-description {
  color: #5871D2;
 
  font-size: 8.5px;
  line-height: 11px;
}
 
.support-link {
  color: #173BB8;
  text-decoration: underline;
}
 
.information-divider {
  width: 1px;
 
  background: #CBD9EC;
 
  flex-shrink: 0;
}
 
.unenrollment-link-container {
  margin-top: 10px;
  text-align: center;
}
 
.unenrollment-link-container a {
  color: #0878e8;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
}
 
.unenrollment-link-container a:hover {
  color: #056bd3;
}
 
 
/* =========================================
   TABLET
========================================= */
 
@media only screen and (max-width: 768px) {
 
  .banner-inner {
    padding-left: 20px;
  }
 
  .outer-card {
    width: calc(100% - 22px);
 
    padding: 15px 15px 14px;
  }
 
  .page-heading p {
    font-size: 12px;
  }
}
 
 
/* =========================================
   MOBILE
========================================= */
 
@media only screen and (max-width: 600px) {
 
  .desktop-break {
    display: none;
  }
 
  .top-banner {
    height: 92px;
  }
 
  .banner-inner {
    height: 58px;
 
    padding-left: 14px;
    padding-top: 9px;
 
    gap: 8px;
  }
 
  .banner-hs-logo {
    width: 50px;
  }
 
  .banner-divider {
    height: 30px;
  }
 
  .banner-tagline {
    font-size: 13px;
    line-height: 17px;
 
    white-space: normal;
  }
 
  .outer-card {
    width: calc(100% - 14px);
 
    margin-top: -34px;
 
    padding: 12px 10px 12px;
  }
 
  .step {
    width: 80px;
  }
 
  .step-number {
    width: 24px;
    height: 24px;
 
    font-size: 10px;
  }
 
  .step-title {
    font-size: 8px;
  }
 
  .step-line {
    width: 40px;
 
    margin-top: 12px;
  }
 
  .page-heading h1 {
    font-size: 20px;
    line-height: 25px;
  }
 
  .page-heading p {
    font-size: 11px;
    line-height: 16px;
  }
 
  .signature-card {
    max-width: 100%;
 
    padding: 12px 12px 14px;
  }
 
  .signature-logo {
    width: 110px;
  }
 
  .savings-banner {
    flex-wrap: wrap;
  }
 
  .benefits-list {
    padding-left: 6px;
  }
 
  .signature-benefit {
    gap: 12px;
  }
 
  .benefit-text {
    font-size: 10.5px;
  }
 
  .benefit-heading {
    font-size: 13px;
    line-height: 18px;
  }
 
  .price-text {
    font-size: 14px;
  }
 
 
  /* =====================================
     MOBILE INFORMATION ICON
  ===================================== */
 
  .account-help {
    position: relative;
 
    width: 20px;
    height: 20px;
 
    flex-shrink: 0;
 
    border-radius: 50%;
 
    background: #DCEEFF;
  }
 
  .account-info-icon {
    width: 14px !important;
    height: 14px !important;
 
    color: #1456D8;
 
    font-size: 14px !important;
  }
 
  .account-help:hover {
    background: #CFE5FF;
  }
 
  .account-help:hover .account-info-icon {
    color: #0E3FA8;
  }
 
 
  /* =====================================
     MOBILE TOOLTIP
     ALWAYS OPENS TO RIGHT
  ===================================== */
 
  .account-tooltip {
    width: 190px;
 
    left: 24px !important;
    right: auto !important;
 
    top: 50% !important;
    bottom: auto !important;
 
    transform:
      translateY(-50%)
      translateX(4px);
 
    white-space: normal;
  }
 
  .account-help:hover .account-tooltip {
    transform:
      translateY(-50%)
      translateX(0);
  }
 
  .account-tooltip::before {
    left: -5px !important;
    right: auto !important;
 
    top: 50% !important;
    bottom: auto !important;
 
    width: 9px;
    height: 9px;
 
    transform:
      translateY(-50%)
      rotate(45deg);
 
    border-left: 1px solid #C6D9EF;
    border-bottom: 1px solid #C6D9EF;
    border-right: none;
  }
 
 
  /* INPUT */
 
  .input-section input {
    font-size: 16px !important;
  }
 
 
  /* BOTTOM INFORMATION */
 
  .information-section {
    flex-direction: column;
 
    gap: 12px;
 
    padding: 12px 4px 4px;
  }
 
  .information-item {
    padding: 0 4px;
  }
 
  .information-divider {
    width: 100%;
    height: 1px;
  }
}
 
 
/* =========================================
   SMALL MOBILE
========================================= */
 
@media only screen and (max-width: 380px) {
 
  .banner-tagline {
    font-size: 12px;
    line-height: 16px;
  }
 
  .step {
    width: 70px;
  }
 
  .step-line {
    width: 27px;
  }
 
  .page-heading h1 {
    font-size: 18px;
  }
 
  .signature-card {
    padding-left: 10px;
    padding-right: 10px;
  }
 
  .account-tooltip {
    width: 175px;
 
    left: 23px !important;
  }
}
 
`;